import { ds24cart_element_id } from "./ds24cart_element_id";
import { ds24cart_jsonp_args } from "./ds24cart_jsonp_args";
import { ds24cart_tooltip_create } from "./ds24cart_tooltip_create";

import { ds24_retrieve } from "../common/ds24_retrieve";
import { ds24cart_id } from "./ds24cart_id";
import { ds24cart_activate_buttons } from "./ds24cart_activate_buttons";
import { 
    ds24cart_isFullscreen, 
    ds24cart_windowHeight, 
    ds24cart_windowScrollLeft, 
    ds24cart_windowScrollTop, 
    ds24cart_windowWidth 
} from "./ds24cart_helper";
import { request } from "../browser/request";
import { setHtml } from "../browser/setHtml";
import { selectElement } from "../browser/selectElement";
import { ds24_checkout_url } from "../common/ds24_checkout_url";

export function ds24cart_show_exec( button_object_or_id: string|HTMLElement )
{

    if (!button_object_or_id) {
        console.log( 'button_object_or_id(): argument button_object_or_id missing. Usage example: <button onclick="return ds24cart_show(this);">Show cart</button>' );
    }

    const button_id = typeof button_object_or_id == 'object'
              ? ds24cart_element_id( button_object_or_id )
              : button_object_or_id;

    const div_id = ds24cart_tooltip_create( button_id, 500, 150 );

    const url = ds24_checkout_url() + '/cart/iframe/'
            + '?' + ds24cart_jsonp_args() + '&div_id='+div_id+'&button_id='+button_id
            + '&div_id=' + div_id;

    request({
        url,
        dataType: 'jsonp',
        success: ds24cart_callback_show
    });
    
}


export function ds24cart_callback_show( result: any )
{
    const div_id  = ds24_retrieve( result, 'div_id' );
    const html    = ds24_retrieve( result, 'html' );
    const cart_id = ds24_retrieve( result, 'cart_id' );

    ds24cart_id( cart_id );

    if (div_id && html)
    {
        setHtml(document.querySelector('#'+div_id+' > div'), html);

        ds24cart_activate_buttons( '#'+div_id );

        const use_full_screen = ds24cart_isFullscreen();

        const tt = document.querySelector<HTMLElement>( 'div.app_cart_tooltip' );
        if (!tt) {
            return;
        }

        if (use_full_screen)
        {
            tt.classList.add( 'app_cart_mobile' );
        }
        else
        {
            tt.classList.remove( 'app_cart_mobile' );

            let other_elements_height = 40;
            document.querySelectorAll('div.app_cart_tooltip div.app_cart_summary, ' + 
                'div.app_cart_tooltip div.app_cart_buttons, ' + 
                'div.app_cart_tooltip div.app_cart_headiline').forEach(element => {
                    other_elements_height = element.getBoundingClientRect().height;
                });

            const window_height = ds24cart_windowHeight();
            const itemlist_height = Math.max( 50, window_height-other_elements_height );

            // Achtung: zuvor wurde der max-height, left, top Wert ohne Einheit geschrieben und hatte
            // wahrscheinlich keine Auswirkung!
            selectElement<HTMLDivElement>('div.app_cart_tooltip div.app_cart_list', list => list.style.maxHeight = itemlist_height + 'px' );

            const { width, height, x, y } = tt.getBoundingClientRect();
            const tt_width  = width;
            const tt_height = height;

            const window_width  = ds24cart_windowWidth();
            

            const max_left = Math.max( 0, ds24cart_windowScrollLeft() + window_width  - tt_width );
            const max_top  = Math.max( 0, ds24cart_windowScrollTop()  + window_height - tt_height );

            if (x > max_left) {
                tt.style.left = max_left + 'px';
                //tt.css( 'left', max_left );
            }

            if (y > max_top) {
                tt.style.top = max_top + 'px';
                //tt.css( 'top', max_top );
            }
        }

    }
}
